import { render, staticRenderFns } from "./orderDelteList.vue?vue&type=template&id=f3f1add0&scoped=true"
import script from "./orderDelteList.vue?vue&type=script&lang=js"
export * from "./orderDelteList.vue?vue&type=script&lang=js"
import style0 from "./orderDelteList.vue?vue&type=style&index=0&id=f3f1add0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f1add0",
  null
  
)

export default component.exports